module.exports = __webpack_public_path__ + "static/media/mixcloud.0abb8654.jpg";